import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getTotalShipments = {
  name: "getTotalShipments" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
